module.exports = __webpack_public_path__ + "static/media/profilePicPlaceholder.aa17f4fc.png";